import {
  RISK_DIAGNOSIS_PROFILE,
  RiskDiagnosisModel,
} from '@ctw/shared/api/fhir/models/risk-diagnosis';
import { searchAllRecords } from '@ctw/shared/api/fqs-rest/search-helpers';
import type { CTWRequestContext, CTWState } from '@ctw/shared/context/ctw-context';

interface GetRiskDiagnosesArgs {
  ctwFetch: CTWState['ctwFetch'];
  requestContext: CTWRequestContext;
  ids: Array<string>;
}

/**
 * Fetches `ExplanationOfBenefit` resources by id via the FQS REST API. EOB is
 * not exposed through the FQS GraphQL schema (no `ExplanationOfBenefitConnection`),
 * so this mirrors `getRiskGapsByIds` and reads over REST instead of an FQS query.
 */
export const getRiskDiagnosesByIds = async ({
  ctwFetch,
  requestContext,
  ids,
}: GetRiskDiagnosesArgs) => {
  return (
    (
      await searchAllRecords(ctwFetch, requestContext, 'ExplanationOfBenefit', {
        _id: ids.join(','),
      })
    )
      .map((eob) => new RiskDiagnosisModel(eob))
      // There is no API for profile filtering, so we filter by profile after the records are loaded
      // to guarantee that all resources are risk diagnoses
      .filter((m) => m.hasProfile(RISK_DIAGNOSIS_PROFILE))
  );
};
